//messages.js
export default {
	id: "Id",
	unit: "Unit",
	unit_abbrev: "Unit Abbrev",
	edit_unit_of_measure: 'Edit Unit Of Measure',
	add_unit_of_measure: 'Add Unit Of Measure',
	delete_unit_of_measure: 'Delete Unit Of Measure',
	units_of_measure: 'Units Of Measure',
	delete_unit_of_measure_confirm: 'This action is not reversible!',
}